import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs/operators';
import {errorHappened, successHappened} from '../app.types';
import {NotificationService} from '../utils/notification-service';

@Injectable()
export class AppGlobalEffects {
  error$ = createEffect(() => this.actions$
    .pipe(
      ofType(errorHappened),
      tap(action => {
        console.log(action.error.message);
        this.notificationService.error(
          `Error \"${action.error.message}\" occured.`
        );
      }),
    ), {dispatch: false});

  success$ = createEffect(() => this.actions$
    .pipe(
      ofType(successHappened),
      tap(action => {
        this.notificationService.success(action.message);
      }),
    ), {dispatch: false});

  constructor(private actions$: Actions,
              private notificationService: NotificationService) {
  }

}
